export function intersectRect(r1, r2) {
  return !(r2.x > r1.x + r1.width || r2.x + r2.width < r1.x || r2.y > r1.y + r1.heigth || r2.x + r2.heigth < r1.x);
}
